const SmsSendLogList = () => import('Views/sms/sms-send-log-list');

export default[
  { path: '/sms-send-log-list', component: SmsSendLogList },
];



// WEBPACK FOOTER //
// ./src/router/smsSendLog.js